import React, { useRef } from "react";
//import PopupMenu from "../PopupMenu/PopupMenu";
//import ExtractButton from "../ExtractButton/ExtractButton";
//import loaderImg from "../../assets/images/gifs/loaderGIF.gif";
import { stockHoldingExportMenu } from "../../utils/constants";
import ExportStocksHoldingList from "./ExportStocksHoldingList";

const StockSelectButton = ({
  onClick,
  isChecked,
  setIsChecked,
  setOverallExcel,
  overallExcel,
}) => {
  const { status } = overallExcel;
  // const [niftyMenu, setNiftyMenu] = useState(false);
  //const popuprefL2 = useRef(null);
  const exportItemRefs = useRef([]);

  // const StockHoldingSelection = ({ onChange, isChecked }) => {
  //   return (
  //     <div className="selection excelSelection">
  //       <input
  //         className="input_checkbox cursor"
  //         type="checkbox"
  //         checked={isChecked}
  //         onChange={onChange}
  //       />
  //       <h3
  //         className={
  //           !isChecked
  //             ? "unchecked_text cursor"
  //             : "unchecked_text checked_text cursor"
  //         }
  //         onClick={onChange}
  //       >
  //         Show me only stocks I’m holding
  //       </h3>
  //     </div>
  //   );
  // };

  // const ExtractDataContent = ({ status }) => {
  //   return (
  //     <div className="extract_data_container stock_container">
  //       <>
  //         <p className="export_data_text">Export Data</p>
  //         <ul className="listitem_container">
  //           <li>
  //             <StockHoldingSelection
  //               onChange={() => setIsChecked((prev) => !prev)}
  //               isChecked={isChecked}
  //             />
  //           </li>
  //           <li
  //             onClick={() => {
  //               onClick({ isChecked });
  //               //setNiftyMenu(false);
  //             }}
  //           >
  //             <div className="listitem_icon excel"></div> Export to Excel
  //           </li>
  //         </ul>
  //         {status === "pending" ? (
  //           <div className="popup_downloader">
  //             <img src={loaderImg} alt="img" />
  //           </div>
  //         ) : status === "fail" ? (
  //           <p className="error_content">Error downloading the file</p>
  //         ) : (
  //           ""
  //         )}
  //       </>
  //     </div>
  //   );
  // };

  // const onClickOutside = useCallback(() => {
  //   //setNiftyMenu(false);
  //   setOverallExcel(({ isOpen, status }) => ({
  //     isOpen: false,
  //     status: status === "pending" ? status : "deafult",
  //   }));
  // }, []);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (popuprefL2.current && !popuprefL2.current.contains(event.target)) {
  //       onClickOutside && onClickOutside();
  //     }
  //   };
  //   document.addEventListener("click", handleClickOutside, true);
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside, true);
  //   };
  // }, [onClickOutside]);

  return (
    <div>
      <div className="download_excel">
        {/* <div ref={popuprefL2}>
          <PopupMenu
            setOpen={() =>
              setOverallExcel(({ status, isOpen }) => ({
                status: status === "pending" ? status : "default",
                isOpen: !isOpen,
              }))
            }
            open={isOpen}
            MenuContent={() => ExtractDataContent({ status })}
          >
            <ExtractButton />
          </PopupMenu>
        </div> */}
        <div className="performane-export-menu reports-export-wrapper ">
          <ExportStocksHoldingList
            buttonProps={{ buttonType: "normalExport", title: "Extract Data" }}
            popupClassName={{
              open: "clicked-hover",
              close: "",
              wrapperClass: "popup_menu_container",
              containerClass: "stock_container",
            }}
            restrictHover={true}
            itemRefs={exportItemRefs}
            menuItems={stockHoldingExportMenu}
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            status={status}
            handleClick={() => onClick({ isChecked })}
            onCustomClose={(isOpen) =>
              setOverallExcel(({ status, isOpen }) => ({
                status: status === "pending" ? status : "default",
                isOpen: !isOpen,
              }))
            }
            accessibilityValues={{
              buttonId: "export-dropdown",
              ariaHaspopup: "menu",
              ariaControls: "extract-menu",
              ariaLabel: "Extract Data",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default StockSelectButton;
